import { z } from 'zod';

export type ReloadType = z.infer<typeof ReloadType>;
export type ReloadRequest = z.infer<typeof ReloadRequest>;

export const ReloadType = z.enum(['definitions', 'collections', 'storageStats', 'queryStats', 'slowQueries']);

export const reloadTypes = ReloadType.options;

export const ReloadRequest = z.object({
  types: ReloadType.array()
    .min(1)
    .default(() => [...reloadTypes]),
});
